import { createSlice } from "@reduxjs/toolkit";

export const planogramThemeSlice = createSlice({
  name: "planogramThemes",
  initialState: {
    "col_100": "rgba(245, 166, 35, 0.15)",
    "col_300": "",
    "col_500": "rgba(245, 166, 35, 0.5)",
    "col_700": "",
    "col_900": "",
    "color": "rgba(245, 166, 35, 1)"
  },
  reducers: {
    changeAccentColor(state, action) {
      state.color = action.payload;

      // calculating colour variants
      const r = action.payload.split("(")[1].split(",")[0];
      const g = action.payload.split("(")[1].split(",")[1];
      const b = action.payload.split("(")[1].split(",")[2].split(")")[0];
      
      state["col_100"] = `rgba(${r}, ${g}, ${b}, 0.15)`
    }
  }
})